/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

/**
 * @module LogsModule
 */

import {
    ChangeDetectionStrategy,
    Component,
    EventEmitter,
    Input,
    Output,
} from '@angular/core';

import { IAviDropdownOption } from 'standalone-components/avi-dropdown/avi-dropdown.types';

import './traffic-logs-vs-dropdown.component.less';

/**
 * @description
 *     A component to select the Virtual Service for Pool Logs.
 *     It populates the VS options and handles changes to the selection.
 * @author Yogesh Patil
 */
@Component({
    selector: 'traffic-logs-vs-dropdown',
    templateUrl: './traffic-logs-vs-dropdown.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TrafficLogsVsDropdownComponent {
    /**
     * ngModel of the VS ID selection dropdown.
     */
    @Input()
    public vsId: string;

    /**
     * VS options for pool logs.
     */
    @Input()
    public vsOptions: IAviDropdownOption[] = [];

    /**
     * Emit the new VS ID when the selection changes.
     */
    @Output()
    public vsIdChange = new EventEmitter<string>();

    /**
     * Load and set the VS based on the VS uuid selected in the dropdown.
     */
    public handleVsChange(vsId: string): void {
        this.vsIdChange.emit(vsId);
    }
}
